import { ExperienceConfigurationKeys } from '@monetize/types/experience-config';
import MEmptyDataPlaceholder from '../../../../components/Monetize/MEmptyDataPlaceholder';
import { QuoteBodyAccordion } from '../../../../components/Quotes/QuoteBodyAccordion';
import { useExperienceConfiguration } from '../../../../hooks';
import { hasVariableAmountProduct } from '../../../../utils/quotes';
import QuoteFormBillingSchedule from '../../Quote/components/QuoteFormBillingSchedule';
import { QuoteFormDiscounts } from '../../Quote/components/QuoteFormDiscounts';
import { QuoteFormPricesSection } from '../../Quote/components/QuoteFormPricesSection';
import { useQuoteContext } from '../../Quote/quoteContext';

export const QuoteInternalBilling = ({ value }: { value?: string }) => {
  const { hideBillingSchedule } = useExperienceConfiguration(
    ExperienceConfigurationKeys.quoteAndContractSettings,
  );
  const { quoteData } = useQuoteContext();
  const { quote } = quoteData;

  const anyVariableAmountProducts = hasVariableAmountProduct(quote);

  const hasOfferings = !!quote?.quoteOfferings?.length;
  const hasDiscounts =
    !!quote && Boolean(quote.discountAmount || quote.discountPercent);
  const hasBillingContent = hasDiscounts || hasOfferings;

  return (
    <QuoteBodyAccordion value={value} title="Billing Summary" mb="0">
      {({ isExpanded }) =>
        hasBillingContent ? (
          <>
            {isExpanded && !hideBillingSchedule && hasOfferings && (
              <QuoteFormBillingSchedule
                loading={quoteData.billingScheduleLoading}
                borderWidth="1px"
                borderRadius="0.25rem"
                mb="6"
                borderColor="tGray.lightPurple"
                itemProps={{ border: 'none' }}
                anyVariableAmountProducts={anyVariableAmountProducts}
              />
            )}
            {isExpanded && hasDiscounts && (
              <QuoteFormDiscounts
                quote={quote}
                borderWidth="1px"
                borderRadius="md"
                borderColor="tGray.lightPurple"
                itemProps={{ border: 'none' }}
              />
            )}
            {isExpanded && quote?.id && hasOfferings && (
              <QuoteFormPricesSection
                quoteId={quote.id}
                currency={quote.currency}
                mt="6"
                borderWidth="1px"
                borderRadius="md"
                borderColor="tGray.lightPurple"
                itemProps={{ border: 'none' }}
              />
            )}
          </>
        ) : (
          <MEmptyDataPlaceholder
            mainMessage="No billing details available"
            smallMessage="Add quote information to see billing discounts, prices, and schedule."
            boxProps={{ height: 'auto' }}
          />
        )
      }
    </QuoteBodyAccordion>
  );
};
